export var DefaultHost;
(function (DefaultHost) {
    DefaultHost["Api"] = "https://api.standardnotes.com";
    DefaultHost["WebSocket"] = "wss://sockets.standardnotes.com";
})(DefaultHost || (DefaultHost = {}));
